module.exports = __webpack_public_path__ + "media/images/quote-icon-9b4efdd73b51d29802f86f1ce5ed176f.svg";